"use strict";

/* Copyright 2019-2020 The MathWorks, Inc. */
define(['dojo/_base/declare', 'dojo/Deferred', 'dojo/dom-construct', 'mw-html-utils/HtmlUtils', 'mw-remote/RemoteEndPointsManager', './utils/SendMessageUtil'], function (declare, Deferred, domConstruct, HtmlUtils, RemoteEndPointsManager, SendMessageUtil) {
  return declare([], {
    constructor: function constructor() {},

    /**
     * Upload artifacts provided to Worker
     *
     * @param {FileList} artifactsList - List of files that have to be uploaded
     * @param {string} fsDest - Location where the file has to be uploaded
     * @param {object} endpoint - Contains the following:
     *                            endpoint: Url of the worker where the upload request is to be sent
     *                            computeSession and routingKey
     * @return {*} a deferred
     */
    upload: function upload(artifactsList, fsDest, opts) {
      var that = this; // New handle is created for every upload request to aid multiple uploads at a time in the future

      this._uploadHandler = new Deferred(function () {
        that.postMessageToUploadIframe('cancelUpload');

        that._unloadIframe();
      });
      this._workerEndpoint = opts.endpoint;

      if (artifactsList instanceof FileList) {
        var uploadToken = {
          csrfToken: undefined,
          validForMs: undefined
        }; // Get the CsrfToken

        var csrfTokenResponseProm = SendMessageUtil.sendPayload(JSON.stringify({
          messages: {
            CreateCsrfToken: [{}]
          }
        }), RemoteEndPointsManager.getEndPointNames().WORKER_ENDPOINT);
        csrfTokenResponseProm.then(function (responses) {
          responses.messages.CreateCsrfTokenResponse.forEach(function (response) {
            if (response.messageFaults && response.messageFaults.length > 0) {// No op
            } else {
              uploadToken = {
                csrfToken: response.csrfToken,
                validForMs: response.validForMs
              };
            }
          });
          var uploadDestinationUrl = encodeURI(opts.uploadIframeProxyUrl) + '&uploadDestinationUrl=' + that._workerEndpoint + 'upload?dest=' + encodeURIComponent(fsDest) + '&csrfToken=' + encodeURIComponent(uploadToken.csrfToken);

          that._createUploadIframe(artifactsList, uploadDestinationUrl);
        });
        return this._uploadHandler;
      }
    },
    _createUploadIframe: function _createUploadIframe(artifactsList, uploadDestinationUrl) {
      var that = this;

      this._eventCallBack = function (event) {
        if (that.getHostName(event.origin) !== that.getHostName(that._workerEndpoint)) {
          return;
        }

        switch (event.data.type) {
          case 'iframeIsReady':
            that.postMessageToUploadIframe(artifactsList);
            break;

          case 'updateProgress':
            that._uploadHandler.progress({
              loaded: event.data.loaded,
              total: event.data.total
            });

            break;

          case 'uploadFinished':
            that._uploadHandler.resolve({
              status: event.data.status,
              response: event.data.response
            });

            that._unloadIframe();

            break;

          case 'uploadError':
            that._uploadHandler.reject({
              status: event.data.status,
              response: event.data.response
            });

            break;

          default:
            break;
          // Do nothing.
        }
      };

      this._uploadIframe = domConstruct.create('iframe', {
        id: 'uploadIframe',
        src: uploadDestinationUrl,
        width: 0,
        height: 0,
        style: 'visibility: hidden; display: none;'
      });
      document.body.appendChild(this._uploadIframe);
      window.addEventListener('message', this._eventCallBack, false);
    },
    _unloadIframe: function _unloadIframe() {
      if (this._uploadIframe) {
        window.removeEventListener('message', this._eventCallBack, false);

        this._uploadIframe.parentNode.removeChild(this._uploadIframe);

        domConstruct.destroy(this._uploadIframe);
        this._uploadIframe = undefined;
      }
    },
    getHostName: function getHostName(url) {
      var parsedUrl = HtmlUtils.parseUrl(url);
      return parsedUrl.hostname;
    },
    postMessageToUploadIframe: function postMessageToUploadIframe(message) {
      this._uploadIframe.contentWindow.postMessage(message, this._workerEndpoint);
    }
  });
});
//# sourceMappingURL=UploadToWorker.js.map
